import React from "react";
import { Row, Col, Space, Typography, Spin, Result } from "antd";

export const AuthenticationLoading: React.FC = () => (
  <Row justify="center" align="middle" style={{ height: "100vh" }}>
    <Col>
      <Result title="Logging you in" icon={<Spin size="large" />} />
    </Col>
  </Row>
);
